const set = require('regenerate')();

exports.characters = set;
exports.strings = ['#\uFE0F\u20E3','*\uFE0F\u20E3','0\uFE0F\u20E3','1\uFE0F\u20E3','2\uFE0F\u20E3','3\uFE0F\u20E3','4\uFE0F\u20E3','5\uFE0F\u20E3','6\uFE0F\u20E3','7\uFE0F\u20E3','8\uFE0F\u20E3','9\uFE0F\u20E3'];
